PegasusTemplate.LinkTypesMixin = Ember.Mixin.create({
  didInsertElement: function(){
    this.set('linkTypes.controller', this.get('controller') );
    this.get('linkTypes.types');
    this._super();
  },

  isUrlInputDisabled: function(){
    return this.get('controller.dataLinkType') === 'Forward';
  }.property('controller.dataLinkType'),

  didChangeLinkType: function(){
    if ( ! this.$() || !this.get('controller.content') ) { return; }

    if ( this.get('controller.dataLinkType') === 'Forward' ) {
      this.set('controller.dataLinkUrl', '{VR_FORWARD_EMAIL_URL}');
    } else {
      this.set('controller.dataLinkUrl', '');
    }
  }.observes('controller.dataLinkType'),

  linkTypes: Em.Object.extend({
    types: function(){
      var forwardToFriendTranslation = Em.I18n.t('g.forward_to_friend').capitalize();
      var websiteTranslation = Em.I18n.t('g.website').capitalize();
      var emailTranslation = Em.I18n.t('g.email').capitalize();
      var types = {
        Website: {
          willPrepend: 'http://',
          test: new RegExp( '^http(s)?:\/\/|^(s)?ftp:\/\/' ),
          display: websiteTranslation
        },
        Email: {
          willPrepend: 'mailto:',
          test: new RegExp( '^mailto:' ),
          display: emailTranslation
        }
      };

      if ( this.get('controller.showForwardEmailOption') ) {
        types['Forward'] = {
          willPrepend: 'http://',
          test: new RegExp( '^http(s)?:\/\/|^(s)?ftp:\/\/' ),
          display: forwardToFriendTranslation
        };
      }

      return types;
    }.property(),

    content: function(){
      var types = this.get('types');
      var content = Object.keys(types).map(function (key) {
        return types[key].display;
      });
      if ( content.length ) {
        return content;
      }
      return [];
    }.property('types.@each.display'),

    selected: 'Website',

    updateSelected: function(){
      if ( !this.get('controller.content.dataLinkType') ) { return; }
      this.set('selected', this.get('types')[ this.get('controller.content.dataLinkType') ].display );
    }.observes('controller.content.dataLinkType'),

    selectedType: function(){
      var types = this.get('types'),
        selected = this.get('selected');

      for( var i in types ){
        if( types.hasOwnProperty( i ) ){
          if( types[i].display === selected ){
            this.set( 'controller.content.dataLinkType', i );
            break;
          }
        }
      }
    }.observes('selected')
  }).create()
});
